import { SET_LOAD_ATTRIBUTE } from 'vx/mutations'

export default {
  computed: {
    loadSize: {
      get () {
        return this.load.size
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'size', value })
      }
    },

    rate: {
      get () {
        return this.load.rate
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'rate', value })
      }
    },

    loadingDate: {
      get () {
        return this.load.loading_date
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'loading_date', value })
      }
    },

    loadingTime: {
      get () {
        return this.load.loading_time
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'loading_time', value })
      }
    },

    deliveryDate: {
      get () {
        return this.load.delivery_date
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'delivery_date', value })
      }
    },

    deliveryTime: {
      get () {
        return this.load.delivery_time
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'delivery_time', value })
      }
    },

    carrier: {
      get () {
        return this.load.carrier_id
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'carrier_id', value })
      }
    },

    truck: {
      get () {
        return this.load.truck_id
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'truck_id', value })
      }
    },

    driver: {
      get () {
        return this.load.driver_id
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'driver_id', value: value })
      }
    },

    truckConfiguration: {
      get () {
        return this.load.truck_configuration_id
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'truck_configuration_id', value })
      }
    },

    notes: {
      get () {
        return this.load.notes
      },

      set (value) {
        this[SET_LOAD_ATTRIBUTE]({ id: this.load.id, attribute: 'notes', value })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/loads/state-mapper.js